import * as React from 'react';
import { useCallback, useMemo, useReducer } from 'react';

import PageHeaderContext from 'bundles/page-header/contexts/PageHeaderContext';
import type { PageHeaderContextType } from 'bundles/page-header/contexts/PageHeaderContext';

export const initialState = { pageHasBackdrop: false };

export const ACTION_TYPES = {
  UPDATE_PAGE_HAS_BACKDROP: 'updatePageHasBackdrop',
} as const;

type UpdatePageHasBackdrop = {
  type: typeof ACTION_TYPES.UPDATE_PAGE_HAS_BACKDROP;
  payload: {
    pageHasBackdrop?: boolean;
  };
};

type Action = UpdatePageHasBackdrop;

export function reducer(state: PageHeaderContextType, action: Action) {
  switch (action.type) {
    case ACTION_TYPES.UPDATE_PAGE_HAS_BACKDROP: {
      const { pageHasBackdrop } = action.payload;
      if (pageHasBackdrop !== state.pageHasBackdrop) {
        return {
          ...state,
          pageHasBackdrop,
        };
      }

      return state;
    }
    default:
      return state;
  }
}

const PageHeaderProvider = ({
  children,
  isSimplifiedPageHeader,
  subNavigationLinks,
  hasUnifiedMetaNav,
  isMobileNavSimplified,
  mobileSubNavigationLinks,
}: PageHeaderContextType & { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
  });

  const updatePageHasBackdrop = useCallback((pageHasBackdrop) => {
    dispatch({
      type: ACTION_TYPES.UPDATE_PAGE_HAS_BACKDROP,
      payload: {
        pageHasBackdrop,
      },
    });
  }, []);

  const value = useMemo(
    () => ({
      ...state,
      updatePageHasBackdrop,
    }),
    [state, updatePageHasBackdrop]
  );

  return (
    <PageHeaderContext.Provider
      value={{
        isSimplifiedPageHeader,
        subNavigationLinks,
        hasUnifiedMetaNav,
        isMobileNavSimplified,
        mobileSubNavigationLinks,
        ...value,
      }}
    >
      {children}
    </PageHeaderContext.Provider>
  );
};

export default PageHeaderProvider;
